// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BLOCKED_COMMENT_PLACEHOLDER = "Skryt\u00fd koment\u00e1r od zablokovan\u00e9ho pou\u017e\u00edvate\u013ea";
export const BLOCKED_REPLY_PLACEHOLDER = "Odpove\u010f na skryt\u00fd koment\u00e1r";
export const FORUM_COMMENT_REMOVE_COMPLAINTS = "Zru\u0161 nahl\u00e1senie odpovede";
